import { TicketTypeResponse } from 'types';
import { baseQuery } from '../baseQuery';

export const getTicketTypes = async () => {
  const { data } = await baseQuery('ticket/types');

  return data as TicketTypeResponse[];
};
